import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, NgModule, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { NotificationService } from '@services/notification.service';
import { TestService } from '@services/test.service';
import { MatSelectFilterModule } from 'mat-select-filter';
import { Editor, NgxEditorModule, Toolbar } from 'ngx-editor';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { Observable } from 'rxjs';
import { AddRecipientDialogboxComponent } from '../add-recipient-dialogbox/add-recipient-dialogbox.component';
import { WebErrorService } from '@services/webError.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { customValidationService } from 'src/app/shared/custom.validator';


export interface Examinee {
  fullName: string;
  examineeuuid: number;
  examineeId: number;
}

@Component({
  selector: 'app-create-private-schedule',
  templateUrl: './create-private-schedule.component.html',
  styleUrls: ['./create-private-schedule.component.scss']
})
export class CreatePrivateScheduleComponent implements OnInit {

  selectedExaminees = [];
  // private schedule form
  privateScheduleForm: FormGroup;

  // date initialization
  minDate: Date;
  minDate1: Date;
  d = new Date();
  timeZoneArr = [];
  zone: any;
  convertStartTime: any;
  minutesToAdd: any;
  setDefaultStartTime: any;
  setDefaultEndTime: any;
  convertEndTime: any;
  dialogBoxData: any;

  // editor initialization
  editor: Editor;
  editor1: Editor;
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  // mat chip and autocomplete
  public allExaminees: Examinee[] = [];

  public chipSelectedExaminee: Examinee[] = [];

  public filteredExaminee: Observable<String[]>;

  private allowFreeTextAddExaminee = false;

  public examineeControl = new FormControl();
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  @ViewChild('examineeInput') examineeInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  setPenaltymsg: boolean;
  setTestScoremsg: boolean;
  isExamineeExist = false;
  getMarksDetails: any;
  isStartTimeValid: boolean;
  isEndTimeValid: boolean;

  // search dropdown
  searchOptions = [];
  selected: any;
  filteredList: any;
  isAllowAttempts: boolean = false;
  maxAttempts: number = 0;
  weeks: number = 0;
  days: number = 0;
  hours: number = 0;
  constructor(private fb: FormBuilder, private testService: TestService, private notificationService: NotificationService, private datePipe: DatePipe, private dialog: MatDialog, private cdr: ChangeDetectorRef, private webErrorService: WebErrorService, private translate: TranslateService
  ) {

    /////////////////////////////////////// date logic ////////////////////////////////////////
    this.minDate = new Date(Date.now() - (3600 * 1000 * 24));
    this.minDate1 = new Date(Date.now() - (3600 * 1000 * 24));
    //  convert time to current time to plus 30 minute
    this.convertStartTime = new Date();
    this.minutesToAdd = new Date(
      this.convertStartTime.setMinutes(this.convertStartTime.getMinutes() + 30)
    );

    this.setDefaultStartTime =
      this.minutesToAdd.getHours() + ':' + this.minutesToAdd.getMinutes();

    this.convertEndTime = this.convertStartTime.setMinutes(
      this.convertStartTime.getMinutes() + 60
    );
    this.setDefaultEndTime =
      this.convertStartTime.getHours() +
      ':' +
      this.convertStartTime.getMinutes();
    ////////////////////////////////////////////////////////////////////////////////////////////

    // editor logic
    this.editor = new Editor();
    this.editor1 = new Editor();
  }

  ngOnInit(): void {
    this.getTimeZone();
    this.buildPrivateScheduleForm();
    this.getMarks();
    // this.filteredExaminee = this.examineeControl.valueChanges.pipe(
    //   map(examineeName => this.filterOnValueChange(examineeName))
    // );
  }

  counter(i: number) {
    return new Array(i);
  }

  // form validation
  get f() {
    this.privateScheduleForm.valueChanges.subscribe(valueChange => {
      this.compareDateAndTime(valueChange);
    });
    return this.privateScheduleForm.controls;

  }
  compareDateAndTime(valueChange): any {
    if (valueChange.startTime == '' || valueChange.startTime == '00:00') {
      this.isStartTimeValid = true;
    } else {
      this.isStartTimeValid = false;
    }
    if (valueChange.endTime == '' || valueChange.endTime == '00:00') {
      this.isEndTimeValid = true;
    } else {
      this.isEndTimeValid = false;
    }
  }

  // create private schedule form
  buildPrivateScheduleForm() {

    this.privateScheduleForm = this.fb.group({
      schName: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(1), Validators.maxLength(120),customValidationService.cannotContainSpace,]),
      schDescription: new FormControl({ value: null, disabled: false }, [Validators.maxLength(480)]),
      startDate: new FormControl({ value: new Date(), disabled: false }, Validators.required),
      startTime: new FormControl({ value: this.setDefaultStartTime, disabled: false }, Validators.required),
      endDate: new FormControl({ value: new Date(), disabled: false }, Validators.required),
      endTime: new FormControl({ value: this.setDefaultEndTime, disabled: false }, Validators.required),
      timeZone: new FormControl({ value: '', disabled: false }, Validators.required),
      testDuration: new FormControl({ value: '10', disabled: false }, [Validators.required, Validators.pattern(/^(?=.*[0-9])(?:[0-9]\d*\.?|0?\.)\d*$/)]),
      testTotalScore: new FormControl({ value: '12', disabled: false }, Validators.required),
      testPassingScore: new FormControl({ value: '1', disabled: false }, Validators.required),
      penaltyPoints: new FormControl({ value: '0', disabled: false }, Validators.required),
      preMessageText: new FormControl({ value: 'Welcome to assessment test', disabled: false }, [Validators.required, Validators.minLength(8), Validators.maxLength(25000)]),
      postMessageText: new FormControl({ value: 'Test submitted successfully', disabled: false }, [Validators.required, Validators.minLength(8), Validators.maxLength(25000)]),
      ExamineeRejoinTest: new FormControl({ value: '', disabled: true }, Validators.required),
      iallquestionsmandatory: new FormControl({ value: false, disabled: false }),
      showResultAfterTest: new FormControl({ value: '', disabled: true }, Validators.required),
      shuffleItems: new FormControl({ value: '', disabled: true }, Validators.required),
      shuffleQuestions: new FormControl({ value: '', disabled: true }, Validators.required),
      shuffleOptions: new FormControl({ value: '', disabled: true }, Validators.required),
      MaxAttempts: new FormControl({ value: 1}),
      Weeks: new FormControl({ value: 0}),
      days: new FormControl({ value: 0}),
      hours: new FormControl({ value: 0}),
      showTools: new FormControl({ value: true, disabled: false }),
      showItemList: new FormControl({ value: true, disabled: false }),
    });
  }

  // merge fname and emailid
  getFnameNemailId(firstName, lastName, emailId) {
    return `${firstName} ${lastName} (${emailId})`;
  }


  /////////////////////////////////////// start add and remove recipient logic //////////////////////////////////////////////
  // add new chip
  // public addExaminee(event: MatChipInputEvent): void {
  //   if (!this.allowFreeTextAddExaminee) {
  //     // only allowed to select from the filtered autocomplete list
  //     return;
  //   }

  //   //
  //   // Only add when MatAutocomplete is not open
  //   // To make sure this does not conflict with OptionSelected Event
  //   //
  //   if (this.matAutocomplete.isOpen) {
  //     return;
  //   }

  //   // Add our examinee
  //   const value = event.value;
  //   if ((value || '').trim()) {
  //     this.selectExamineeByName(value.trim());
  //   }

  //   this.resetInputs();
  // }

  // remove chip
  // public removeExaminee(examinee: Examinee): void {
  //   const index = this.chipSelectedExaminee.indexOf(examinee);
  //   if (index >= 0) {
  //     this.chipSelectedExaminee.splice(index, 1);
  //     if (this.chipSelectedExaminee.length === 0) {
  //       this.isExamineeExist = true;
  //       return;
  //     }
  //     this.resetInputs();
  //   }
  // }

  // selected examinee
  // public selectedExaminee(event: MatAutocompleteSelectedEvent): void {
  //   this.selectExamineeByName(event.option.value);
  //   this.resetInputs();
  // }

  // reset add recipient input box
  // private resetInputs() {
  //   // clear input element
  //   this.examineeInput.nativeElement.value = '';
  //   // clear control value and trigger examineeControl.valueChanges event
  //   this.examineeControl.setValue(null);
  // }

  // // filter add recipient input box on change value
  // private filterOnValueChange(examineeName: string | null): String[] {
  //   let result: String[] = [];
  //   //
  //   // Remove the examinees we have already selected from all examinees to
  //   // get a starting point for the autocomplete list.
  //   //
  //   let allExamineesLessSelected = this.allExaminees.filter(examinee => this.chipSelectedExaminee.indexOf(examinee) < 0);
  //   if (examineeName) {
  //     result = this.filterExaminee(allExamineesLessSelected, examineeName);
  //   } else {
  //     result = allExamineesLessSelected.map(examinee => examinee.fullName);
  //   }
  //   return result;
  // }

  // // filter examinee after detect any change
  // private filterExaminee(examineeList: Examinee[], examineeName: String): String[] {
  //   let filteredExamineeList: Examinee[] = [];
  //   const filterValue = examineeName.toLowerCase();
  //   let examineesMatchingEngineerName = examineeList.filter(examinee => examinee.fullName.toLowerCase().indexOf(filterValue) === 0);
  //   if (examineesMatchingEngineerName.length || this.allowFreeTextAddExaminee) {
  //     //
  //     // either the examinee name matched some autocomplete options
  //     // or the name didn't match but we're allowing
  //     // non-autocomplete examinee names to be entered
  //     //
  //     filteredExamineeList = examineesMatchingEngineerName;
  //   } else {
  //     //
  //     // the examinee name didn't match the autocomplete list
  //     // and we're only allowing examinees to be selected from the list
  //     // so we show the whjole list
  //     //
  //     filteredExamineeList = examineeList;
  //   }
  //   //
  //   // Convert filtered list of examinee objects to list of examinee
  //   // name strings and return it
  //   //
  //   return filteredExamineeList.map(examinee => examinee.fullName);
  // }


  // private selectExamineeByName(examineeName) {
  //   let foundExaminee = this.allExaminees.filter(examinee => examinee.fullName == examineeName);
  //   if (foundExaminee.length) {
  //     //
  //     // We found the examinee name in the allExaminees list
  //     //
  //     this.chipSelectedExaminee.push(foundExaminee[0]);
  //     if (this.chipSelectedExaminee.length > 0) {
  //       this.isExamineeExist = false;
  //       return;
  //     }
  //   }
  // }

  /////////////////////////////////////// end add and remove recipient logic //////////////////////////////////////////////

  ////////////////////////////////////// not used anywhere in html /////////////////////////////////////////////////////////
  testScoreChange() {
    if (
      this.privateScheduleForm?.value?.testPassingScore + 1 >
      // this.scheduleForm.controls['testPassingScore'].value || this.scheduleForm.controls['penaltyPoint'].value >
      this.privateScheduleForm?.value?.testTotalScore
    ) {

      this.setTestScoremsg = true;
      setTimeout(() => {
        this.setTestScoremsg = false;
      }, 1000);
      // this.privateScheduleForm.value.testPassingScore.patchValue({ testPassingScore: '0' });
    } else {
      this.setTestScoremsg = false;
    }

  }


  checkTestValue() {
    if (
      this.privateScheduleForm.value.penaltyPoints + 1 >
      this.privateScheduleForm?.value?.testTotalScore
    ) {
      this.setPenaltymsg = true;
      // this.privateScheduleForm.patchValue({ penaltyPoints: '0' });
    } else {
      this.setPenaltymsg = false;
    }

  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////


  // get all time zones
  getTimeZone(): void {
    this.testService.getTimeZone().subscribe((timezonedata) => {
      this.timeZoneArr = timezonedata?.data;
      // Dropdown Search filter
      this.searchOptions = this.timeZoneArr;
      this.selected = this.searchOptions[0]?.name;
      this.filteredList = this.searchOptions.slice();
    },
    (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });
  }

  // get all existing private examinees
  getPrivateExaminees(): void {
    this.testService.getExamineetoSchedule().subscribe((resData) => {
      const fullInfo = resData.items.map((value) => (
        { fullName: this.getFnameNemailId(value['firstName'], value['lastName'], value['emailId']), examineeuuid: value['examineeuuid'], examineeId: value['examineeId'], active: value['active'] }
      ));
      this.allExaminees = fullInfo;
    },
    (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });
  }

  // get marks
  getMarks(): void {
    const testuuid = sessionStorage.getItem('testuuid');
    const marks = this.testService.getTestToltalScore(testuuid).subscribe((resData) => {
      this.privateScheduleForm.patchValue({
        testTotalScore: resData?.data?.totalMarks, testPassingScore: resData?.data?.passingCriteria, testDuration: resData?.data?.duration, timeZone: resData?.data?.collectionTimeZone
      });
    },
    (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });
  }

  // navigate to back
  back() {
    this.testService.scheduleBackBtnobs.next(false);
  }


  // open add recipient dialog box
  addRecipientDialogbox(): void {
    this.isExamineeExist = false;
    this.testService.getExamineetoSchedule().subscribe((resData) => {
      this.dialogBoxData = resData?.items;
      this.dialogBoxData.forEach(tableElement => {
        tableElement['checked'] = false;
      });

      this.selectedExaminees?.forEach(element => {
        let b = this.dialogBoxData.findIndex((x) => x.examineeuuid === element?.examineeuuid);
        this.dialogBoxData[b].checked = true;
      })

      const dialogRef = this.dialog.open(AddRecipientDialogboxComponent, {
        disableClose: false,
        width: '60%',
        panelClass: 'add-recipient-container',
        data: {data : this.dialogBoxData , selected: this.selectedExaminees},
      });

      dialogRef.afterClosed().subscribe(result => {
        const fullInfo = result?.map((value) => (
          { fullName: this.getFnameNemailId(value['firstName'], value['lastName'], value['emailId']), examineeuuid: value['examineeuuid'], examineeId: value['examineeId'], active: value['active'] }
        ));
        if (result == undefined) {
          this.selectedExaminees = [];
        } else {
          this.selectedExaminees = fullInfo;

        }

        this.chipSelectedExaminee = this.selectedExaminees;
        this.cdr.detectChanges();
      });
    },
    (error: any) => {
      this.webErrorService.handleAPIErrors(error);
    });
  }

  // remove examinee from list
  removeExamineeFromArray(chip) {
    this.selectedExaminees = this.selectedExaminees.filter(value => value?.examineeuuid !== chip?.examineeuuid);
    if (this.selectedExaminees.length === 0) {
      this.isExamineeExist = true;
    }
    this.chipSelectedExaminee = this.selectedExaminees;
  }


  // submit private schedule form
  onSubmit(form) {
    if (this.chipSelectedExaminee.length <= 0) {
      this.isExamineeExist = true;
      return;
    }

    // if (form.value.testPassingScore > form.value.testTotalScore) {
    //   this.webErrorService.customErrors('Passing Score can not be greater than test score', true, 'warn')
    //   return;
    // }

    // if (form.value.penaltyPoints > form.value.testTotalScore) {
    //   this.webErrorService.customErrors('Penalty points can not be greater than test score', true, 'warn')
    //   return;
    // }

    let newDate: Date = new Date();
    let schEndDate = this.privateScheduleForm.value.startDate;

    if (parseInt(form.value?.Weeks) > 0) newDate.setDate(schEndDate.getDate() + parseInt(form.value?.Weeks) * 7);
    if (parseInt(form.value?.days) > 0) newDate.setDate(newDate.getDate() + parseInt(form.value?.days))
    if (parseInt(form.value?.hours) > 0) {
      // let startTime = this.publicScheduleForm.value.startTime;
      // newDate.setHours(startTime + parseInt(form.value?.hours))
    }

    if (parseInt(form.value?.Weeks) > 0 || parseInt(form.value?.days) > 0 || parseInt(form.value?.hours) > 0) {
      if (((this.datePipe.transform(this.privateScheduleForm.value.endDate, 'yyyy-MM-dd')) < this.datePipe.transform(newDate, 'yyyy-MM-dd'))
         ) {
        this.webErrorService.customErrors(this.translate.instant('test.editSchedule.public.AttemptError'), true, 'warn');
        return;
      }
      // console.log(this.publicScheduleForm.value.endTime)
      // console.log(newDate.getHours() + ':'+ newDate.getMinutes())
      // if (((this.datePipe.transform(this.publicScheduleForm.value.endDate, 'yyyy-MM-dd')) <= this.datePipe.transform(newDate, 'yyyy-MM-dd') &&
      // this.publicScheduleForm.value.endTime < (newDate.getHours() + ':'+ newDate.getMinutes()))) {
      //   alert('Please select schedule time');
      // }
    }

    const finalPayload = this.getFinalPayload(form);
    this.testService.addTestSchedule(finalPayload).subscribe((resData) => {
      if (resData.success) {
        this.notificationService.success(resData?.message);
        this.back();
      }
    },
    (error: any) => {
      this.webErrorService.handleAPIErrors(error, null, true, 'warn');
    });
  }

  // construct api payload
  getFinalPayload(payload): any {
    const examinneIds = this.chipSelectedExaminee.map((value) => value.examineeId);
    return payload = {
      examinees: examinneIds,
      publicScheduleParameters: {
        parameters: []
      },
      clientuuId: JSON.parse(sessionStorage?.getItem('currentUser'))?.clientuuId,
      collectionId: sessionStorage.getItem('defaultcollectionid'),
      description: payload?.value?.schDescription?.trim() || null,
      endDate: this.datePipe.transform(payload.value.endDate, 'yyyy-MM-dd'),
      endDateHours: payload.value.endTime.split(':')[0],
      endDateMinutes: payload.value.endTime.split(':')[1],
      postTestMessage: {
        description: payload?.value?.postMessageText?.trim(),
        mediaURL: [
          "String"
        ]
      },
      preTestMessage: {
        description: payload?.value?.preMessageText?.trim(),
        mediaURL: [
          "String"
        ]
      },
      scheduleType: false,
      startDate: this.datePipe.transform(payload.value.startDate, 'yyyy-MM-dd'),
      startDateHours: payload.value.startTime.split(':')[0],
      startDateMinutes: payload.value.startTime.split(':')[1],
      testBankId: sessionStorage.getItem('testBankId'),
      testDuration: payload?.value?.testDuration,
      testPassingScore: JSON.parse(payload?.value?.testPassingScore),
      iallquestionsmandatory: payload?.value?.iallquestionsmandatory,
      testScore: JSON.parse(payload?.value?.testTotalScore),
      penaltyPoint: payload?.value?.penaltyPoints,
      timeZoneName: payload?.value?.timeZone,
      title: payload.value.schName?.trim(),
      maxnumberofattempts: payload?.value?.MaxAttempts,
      allowreattemptafterweeks: payload?.value?.MaxAttempts == 0 ? payload?.value?.Weeks.value : payload?.value?.Weeks,
      allowreattemptafterdays: payload?.value?.MaxAttempts == 0 ? payload?.value?.days.value : payload?.value?.days,
      allowreattemptafterhours: payload?.value?.MaxAttempts == 0 ? payload?.value?.hours.value : payload?.value?.hours,
      showtools: payload?.value?.showTools,
      showitemlist: payload?.value?.showItemList
    }
  }

  onSelectMaxAttempts(event) {
    console.log(event.target.value);
    if (event.target.value != 0) {
      this.isAllowAttempts = true;
    } else {
      this.privateScheduleForm.value.Weeks = 0;
      this.privateScheduleForm.value.days = 0;
      this.privateScheduleForm.value.hours = 0;
      this.weeks = 0;
      this.days = 0;
      this.hours = 0;
      this.isAllowAttempts = false;
    }
  }

}

@NgModule({
  declarations: [
    CreatePrivateScheduleComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatChipsModule,
    MatIconModule,
    MatInputModule,
    MatCheckboxModule,
    MatDatepickerModule,
    NgxMaterialTimepickerModule,
    MatSlideToggleModule,
    NgxEditorModule,
    MatButtonModule,
    MatSelectModule,
    MatDialogModule,
    MatTableModule,
    MatPaginatorModule,
    MatSelectFilterModule,
    TranslateModule
  ]
})
class CreatePrivateScheduleComponentModule {

}
